<app-loading-overlay [loading]="isLoading">
  <div class="row identification identification__row">
    <div class="col-12 identification__intro">
      <h3 *appApplyIfNotEmpty="translationService.getTranslation('identification_intro')"
          [innerHTML]="translationService.getTranslation('identification_intro')"
          class="identification__intro-title"></h3>
    </div>
    <div class="col-12 mb-3 identification__description">
      <h4 [innerHTML]="translationService.getTranslation('identification_description')"
          class="identification__description-title"></h4>
    </div>
  </div>

  <mat-card class="mt-3 identification__card">
    <mat-card-content class="identification__card-content">
      <div class="row mt-3 identification__form-row">
        <div class="col-12 identification__form-col">
          @if (errorsArr.length > 0) {
            <app-general-errors [errors]="errorsArr" class="identification__errors"></app-general-errors>
          }
          <div class="identification__customer-type">
            <mat-radio-group [(ngModel)]="customerType"
                             class="d-flex gap-4 align-items-center identification__customer-type-group">
              <mat-radio-button [value]="CustomerType.PRIVATE" labelPosition="after"
                                class="identification__customer-type-radio">{{ translationService.getTranslation('customer_private') }}
              </mat-radio-button>
              <mat-radio-button [value]="CustomerType.COMPANY" labelPosition="after"
                                class="identification__customer-type-radio">{{ translationService.getTranslation('customer_company') }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <br>

          <app-hup-subscription-address [controlGroup]="formGroup.get('searchAddress')" [showTitle]="false"
                                        [showSalutation]="false" [showAddressExt1]="false" [customerType]="customerType"
                                        [identification]="true"
                                        class="identification__subscription-address"></app-hup-subscription-address>
          @if (this.formGroup.get('searchAddress').get('person').valid && this.formGroup.get('searchAddress').get('address').valid) {
            <div class="mt-2 text-center identification__search-btn-row">
              @if (!identificationData) {
                <button mat-raised-button color="primary" (click)="loadAddress()"
                        class="identification__search-btn">{{ translationService.getTranslation('identification_search_address') }}
                </button>
              }
            </div>
          }
          @if (identificationData && identificationData.maskedExtendedData && identificationData.maskedExtendedData.size > 0) {
            <ng-container [formGroup]="formGroup.get('searchAddress')" class="identification__extended-container">
              <div class="mt-5" formGroupName="extendedValues" class="identification__extended-values">
                <div class="mb-2 identification__masked-overview" [innerHTML]="maskedOverviewText"></div>
                @if (showBirthday) {
                  <div class="row mt-2 identification__row-birthday">
                    <div
                      class="col-12 col-md-6 text-end my-auto identification__label-birthday">{{ translationService.getTranslation('address_birthday') }} {{ this.identificationData.maskedExtendedData.get('BIRTHDAY') }}
                    </div>
                    <div class="col-12 col-md-6 identification__input-birthday">
                      <mat-form-field class="identification__form-field">
                        <mat-label [innerHTML]="translationService.getTranslation('address_birthday')"></mat-label>
                        <input matInput formControlName="birthday">
                        @if (formGroup.get('searchAddress.extendedValues.birthday')?.invalid) {
                          <mat-error>
                            {{ translationService.getTranslation('identification_wrong_birthday') }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                }
                @if (showIBAN) {
                  <div class="row mt-2 identification__row-iban">
                    <div
                      class="col-12 col-md-6 text-end my-auto identification__label-iban">{{ translationService.getTranslation('payment_iban') }} {{ this.identificationData.maskedExtendedData.get('IBAN') }}
                    </div>
                    <div class="col-12 col-md-6 identification__input-iban">
                      <mat-form-field class="identification__form-field">
                        <mat-label [innerHTML]="translationService.getTranslation('payment_iban')"></mat-label>
                        <input matInput formControlName="iban">
                        @if (formGroup.get('searchAddress.extendedValues.iban')?.invalid) {
                          <mat-error>
                            {{ translationService.getTranslation('identification_wrong_iban') }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                }
                @if (showPhone) {
                  <div class="row mt-2 identification__row-phone">
                    <div
                      class="col-12 col-md-6 text-end my-auto identification__label-phone">{{ translationService.getTranslation('address_telephone') }} {{ this.identificationData.maskedExtendedData.get('PHONE') }}
                    </div>
                    <div class="col-12 col-md-6 identification__input-phone">
                      <mat-form-field class="identification__form-field">
                        <mat-label [innerHTML]="translationService.getTranslation('address_telephone')"></mat-label>
                        <input matInput formControlName="phone">
                        @if (formGroup.get('searchAddress.extendedValues.phone')?.invalid) {
                          <mat-error>
                            {{ translationService.getTranslation('identification_wrong_phone') }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                }
                @if (showEmail) {
                  <div class="row mt-2 identification__row-email">
                    <div
                      class="col-12 col-md-6 text-end my-auto identification__label-email">{{ translationService.getTranslation('address_email') }} {{ this.identificationData.maskedExtendedData.get('EMAIL') }}
                    </div>
                    <div class="col-12 col-md-6 identification__input-email">
                      <mat-form-field class="identification__form-field">
                        <mat-label [innerHTML]="translationService.getTranslation('address_email')"></mat-label>
                        <input matInput formControlName="email">
                        @if (formGroup.get('searchAddress.extendedValues.email')?.invalid) {
                          <mat-error>
                            {{ translationService.getTranslation('identification_wrong_email') }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                }
                @if (showClientNo) {
                  <div class="row mt-2 identification__row-clientno">
                    <div
                      class="col-12 col-md-6 text-end my-auto identification__label-clientno">{{ translationService.getTranslation('label_backendid') }} {{ this.identificationData.maskedExtendedData.get('CLIENTNO') }}
                    </div>
                    <div class="col-12 col-md-6 identification__input-clientno">
                      <mat-form-field class="identification__form-field">
                        <mat-label [innerHTML]="translationService.getTranslation('label_backendid')"></mat-label>
                        <input matInput formControlName="clientNo">
                        @if (formGroup.get('searchAddress.extendedValues.clientNo')?.invalid) {
                          <mat-error>
                            {{ translationService.getTranslation('identification_wrong_clientNo') }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                }
                <div class="mt-2 text-center identification__check-btn-row">
                  @if (!identificationData.user) {
                    <button mat-raised-button color="primary" (click)="checkMaskedData()"
                            class="identification__check-btn">{{ translationService.getTranslation('identification_check_extended_values') }}
                    </button>
                  }
                </div>
                @if (identificationData.user) {
                  <div class="row mt-5 identification__register-row">
                    @if (returnPath && !forceRegistration && !registeringAgreed) {
                      <div class="row mb-3 justify-content-between identification__register-options-row">
                        <div class="options-text text-center identification__register-options-text"
                             [innerHTML]="translationService.getTranslation('identification.next_options')"></div>
                        <div class="btn-container justify-content-between identification__register-btn-container">
                          <button mat-flat-button
                                  class="btn btn-secondary col-5 identification__register-btn"
                                  (click)="continueWithoutRegistration()"
                                  [innerHTML]="translationService.getTranslation('identification_continueWithoutRegistration')">
                          </button>
                          <button mat-raised-button
                                  class="btn col-5 identification__register-btn" color="primary"
                                  (click)="registeringAgreed = true;"
                                  [innerHTML]="translationService.getTranslation('identification_continueWithRegistration')">
                          </button>
                        </div>
                      </div>
                    }
                    @if (registeringAgreed || !returnPath || forceRegistration) {
                      <div class="mb-2 identification__register-email-overview"
                           [innerHTML]="translationService.getTranslation('identification_registration_email_overview')"></div>
                      @if (!identificationData.matchEmail) {
                        @if (showEmail && formGroup.get('searchAddress.extendedValues.email').value !== '') {
                          <div class="col-12 col-md-6 offset-md-6 identification__register-checkbox">
                            <mat-checkbox formControlName="copyEmail" class="identification__register-checkbox-input">
                              <div
                                [innerHTML]="translationService.getTranslation('identification_registration_same_email')"></div>
                            </mat-checkbox>
                          </div>
                        }
                      }
                      <div
                        class="col-12 col-md-6 text-end my-auto identification__register-label-email">{{ translationService.getTranslation('address_email') }}
                      </div>
                      <div class="col-12 col-md-6 identification__register-input-email">
                        <mat-form-field class="identification__form-field">
                          <mat-label [innerHTML]="translationService.getTranslation('address_email')"></mat-label>
                          <input matInput (keyup.enter)="createAccount()" formControlName="registerEmail" [readonly]="identificationData.matchEmail">
                          @if (formGroup.get('searchAddress.extendedValues.registerEmail').pending) {
                            <mat-spinner class="iconInInput identification__register-spinner"
                                         matSuffix [diameter]="18"
                                         style="float: right; margin-left: 18px"></mat-spinner>
                          }
                          @if (formGroup.get('searchAddress.extendedValues.registerEmail').valid) {
                            <mat-icon class="iconInInput identification__register-icon" matSuffix>
                              check
                            </mat-icon>
                          }
                          @if (formGroup.get('searchAddress.extendedValues.registerEmail').hasError('message')) {
                            <mat-error>
                              {{ formGroup.get('searchAddress.extendedValues.registerEmail').getError('message') }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      @if (formGroup.get('searchAddress.extendedValues.registerEmail').valid) {
                        <div class="mt-2 identification__register-description">
                          <div
                            [innerHTML]="translationService.getTranslation('identification_register_description')"></div>
                          <div class="mt-2 text-center identification__register-create-btn-row">
                            <button mat-raised-button color="primary" (click)="createAccount()"
                                    class="identification__register-create-btn">{{ translationService.getTranslation('identification_create_account') }}
                            </button>
                          </div>
                        </div>
                      }
                      @if (formGroup.get('searchAddress.extendedValues.registerEmail').hasError('message')) {
                        <div class="mt-2 identification__register-login-description">
                          <div
                            [innerHTML]="translationService.getTranslation('identification_go_to_login_description')"></div>
                          <div class="mt-2 text-center identification__register-login-btn-row">
                            <button mat-raised-button color="primary" (click)="goToLogin()"
                                    class="identification__register-login-btn">{{ translationService.getTranslation('identification_go_to_login') }}
                            </button>
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            </ng-container>
          }
          @if (searched && notFoundAddress) {
            <div class="mt-5 identification__notfound-address"
                 [innerHTML]="translationService.getTranslation('identification_notFoundUser')"></div>
          }
          @if (searched && notFoundExtendedData) {
            <div class="mt-5 identification__notfound-extended"
                 [innerHTML]="translationService.getTranslation('identification_notFoundExtendedData')"></div>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</app-loading-overlay>
